// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1lO8C","title":"AfterFrontImage_title___q8Lx"};